import { Button, Pagination } from '@mui/material'
import React, { useState } from 'react'
import { useAllVacancyQuery } from '../../../helpers/vacancyApi'
import Loader from '../../../components/Loader/Loader'
import { useNavigate } from 'react-router-dom'


const Vacany = () => {

    const navigate = useNavigate()

    const [page, setpage] = useState(1)

    const { data, isFetching } = useAllVacancyQuery(page)

    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 w-[90%] md:w-full md:px-4'>

            <div>
                <h1
                    className='text-xl md:text-2xl dark:text-white font-bold text-center'
                >
                    Open <span className='text-yellow-500'>Vacancy</span>
                </h1>
            </div>

            <div className='max-w-screen-xl mx-auto mt-5 md:mt-10'>
                <div className='hidden md:grid grid-cols-6 bg-white transition-all duration-700 dark:bg-slate-700 items-center gap-3 p-2 rounded-md shadow-md'>
                    <div>
                        <h1 className='font-bold text-red-500 text-sm'>
                            Open Positions
                        </h1>
                    </div>
                    <div className='col-span-3'>
                        <h1 className=' text-sm font-bold dark:text-white'>
                            Description
                        </h1>
                    </div>
                    <div >
                        <h1 className='text-sm font-bold dark:text-white'>
                            Location
                        </h1>
                    </div>
                    <div className='bg-pink'>
                        <h1 className='text-center  text-sm font-bold dark:text-white'>
                            Status
                        </h1>
                    </div>
                </div>
                {isFetching ? (
                    <Loader text={'Loading vacancies...'} height='40vh' />
                ) : (
                    <div className='mt-2 bg-white dark:bg-slate-700 transition-all duration-700 rounded-md shadow-md max-h-[510px] overflow-y-auto'>
                        {data.vacancy.map((item, i) => {

                            let startDate = new Date(item.startTime)
                            let endDate = new Date(item.endTime)

                            const startTime = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
                            const endTime = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

                            const result = `${startTime} to ${endTime}`;

                            return <div key={i} className='grid grid-cols-1 md:grid-cols-6 px-2 py-4 gap-3 hover:bg-slate-100 dark:hover:bg-slate-600 duration-700'>
                                <div>
                                    <h1
                                        className='font-bold text-xs dark:text-white cursor-pointer'
                                        onClick={() => navigate(`/vacancy/${item.slug}`)}
                                    >
                                        {item.title}
                                    </h1>
                                    <h6 className='text-[17px] mt-1 text-gray-700 dark:text-gray-400'>{result}</h6>
                                </div>
                                <div className='md:col-span-3'>
                                    <p className='text-[16px] dark:text-gray-200'>
                                        {item.shortdesc}
                                    </p>
                                </div>
                                <div>
                                    <h2 className='text-xs font-bold text-gray-600 dark:text-gray-400'>
                                        {item.location}
                                    </h2>
                                </div>
                                <div className='flex justify-end md:justify-center'>
                                    <div>
                                        <Button
                                            variant='contained' color='error'
                                            className='blob-btn'
                                            size='large'
                                            onClick={() => navigate(`/vacancy/${item.slug}`)}
                                            sx={{
                                                borderRadius: '30px',
                                                fontSize: { xs: '13px', sm: '12px', md: '15px' },
                                                backgroundColor: '#ff9800 !important',
                                                textTransform: 'none',
                                                transition: 'all 0.7s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                                                    transform: 'scale(1.1)'
                                                }
                                            }}
                                        >
                                            Apply Now
                                            <span className="blob-btn__inner">
                                                <span className="blob-btn__blobs">
                                                    <span className="blob-btn__blob"></span>
                                                    <span className="blob-btn__blob"></span>
                                                    <span className="blob-btn__blob"></span>
                                                    <span className="blob-btn__blob"></span>
                                                </span>
                                            </span>

                                        </Button>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                )}

                <div className='flex justify-center my-3'>
                    {data && data.resultPerPage < data.filteredVacancyCount && (

                        <Pagination color='primary' size='medium'
                            count={Math.ceil(data.totalVacancyCount / data.resultPerPage)}
                            page={page}
                            shape='rounded'
                            onChange={(event, value) => setpage(value)}
                            showLastButton showFirstButton hideNextButton hidePrevButton

                        />
                    )}
                </div>


            </div>


        </div>
    )
}

export default Vacany